import { formatCurrencyAbbreviation } from "../../utilities/numericFormat.js";
export const questionTypes = {
	YES_NO: [
		{ value: "yes", label: "yes" },
		{ value: "no", label: "no" },
	],
	ONE_TWO: [
		{ value: "one", label: "1" },
		{ value: "two", label: "2" },
	],
};

export const notificationCardItems = (
	cardType,
	title,
	message,
	additionalText = null
) => {
	return {
		cardType,
		title,
		message,
		additionalText,
	};
};

export const questionLabels = {
	PEOPLE_QUESTION: "Number of people to be insured?",
	RESIDENT_QUESTION: "Are you a Permanent Resident of Australia?",
	TOBACCO_QUESTION:
		"Have you smoked tobacco or any other substance in the last 12 months?",
	OTHER_INSURANCE_QUESTION: "Do you have any other insurance with Allianz?",
	TRAUMA_COVER_QUESTION: {
		label: "All Critical Illness (Trauma) Cover",
		description: {
			online: `Do you have Critical Illness, Trauma, or similar cover with any other insurer, and if so, will the total cover (including this application) exceed $2 million?`,
			contactCentre: `Do you have Critical Illness, Trauma, or similar cover with any other insurer, and if so, will the total cover (including this application) exceed $2 million?`,
		},
	},
	CC_EMAIL_POLICY_INFO: "Is policy information to be provided by email?",
	BANK_GRANT_PERMISSIONS_QUESTION:
		"Do we have permission to deduct the premium directly from your bank account?",
};
